/**
 * Site-wide certificates promo (`certificates-promotions`): one promo spanning
 * the certificate surfaces — certs, bundles, the homepage, and the subscription.
 * Server-side, `CertificateSpecialPromo` applies its coupon to the charged
 * products (certs, bundles, and the FCC subscription — not the homepage, which
 * never charges). The FE reads this flag for the **cert, homepage, and
 * subscription** promo surfaces (`getPromoVariables`) and the cert client hook
 * (`useCertificatePromoVariables`), resolving it **site-wide-first** so it takes
 * precedence over the per-surface `mccerts-promo-{promoSurface}` promo. Rollout
 * flag, active in the `variant_1` bucket.
 */
export const SITE_WIDE_PROMO_FLAG = 'certificates-promotions'

/**
 * GrowthBook flag id for a **promo surface** — a certificate slug, `homepage`, or
 * `subscription`. Single-sources the `mccerts-promo-` prefix across the SSR
 * fetchers and the client hook.
 *
 * Usually distinct from a `ProductSurface` value: a cert/bundle's per-slug flag
 * is built from its own slug, so `'cert'`/`'bundle'` are never arguments here.
 * `'subscription'` is the one surface where the two coincide — the promo
 * surface (`mccerts-promo-subscription`) and the `productSurface` override key
 * (`productSurface.subscription`) share the same literal, since there is only
 * ever one subscription page.
 */
export const promoFlagKey = (promoSurface: string): string =>
  `mccerts-promo-${promoSurface}`
